import { render, staticRenderFns } from "./Ozon.vue?vue&type=template&id=7903b220&scoped=true"
import script from "./Ozon.vue?vue&type=script&lang=js"
export * from "./Ozon.vue?vue&type=script&lang=js"
import style0 from "./Ozon.vue?vue&type=style&index=0&id=7903b220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7903b220",
  null
  
)

export default component.exports